import { intelligentPhotoCaptureConstants } from '../constants';
export const INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_SUMMARY_SUBMIT_REQUEST = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_ESTIMATOR_SUMMARY_SUBMIT_REQUEST`;
export const INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_SUMMARY_SUBMIT_SUCCESS = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_ESTIMATOR_SUMMARY_SUBMIT_SUCCESS`;
/**
 * Action creator for requesting estimator summary submit
 * @param companyCode - The company code
 * @param contextId - The context identifier
 * @returns Action with type and payload
 */
export const photoCaptureIntelligentEstimatorSummarySubmitRequestAction = (companyCode, contextId) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_SUMMARY_SUBMIT_REQUEST,
    payload: { companyCode, contextId }
});
/**
 * Action creator for estimator summary submit success
 * @param response - The API response for estimator summary submit
 * @returns Action with type and payload
 */
export const photoCaptureIntelligentEstimatorSummarySubmitSuccessAction = (response) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_SUMMARY_SUBMIT_SUCCESS,
    payload: { response }
});
//# sourceMappingURL=photoCaptureIntelligentEstimatorSummarySubmitAction.js.map